export default {
  MENU: (state) => state.menu,
};
